document.addEventListener("DOMContentLoaded", function () {
  const menuBtn = document.querySelector(".nlh-menu-btn");
  const closeBtn = document.querySelector(".nlh-close");
  const drawer = document.querySelector(".nlh-drawer");
  const overlay = document.querySelector(".nlh-overlay");
  const wrapper = document.querySelector(".nlh-wrapper");

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add("active");
    overlay.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove("active");
    overlay.classList.remove("active");
    document.body.style.overflow = "";
  }

  if (menuBtn) {
    menuBtn.addEventListener("click", openDrawer);
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closeDrawer);
  }

  if (overlay) {
    overlay.addEventListener("click", closeDrawer);
  }

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeDrawer();
    }
  });

  if (wrapper) {
    wrapper.addEventListener("mousemove", function (event) {
      const bottle = wrapper.querySelector(
        ".nlh-bottle, .nlh-placeholder-bottle"
      );
      const notes = wrapper.querySelectorAll(".nlh-note");

      const x = (event.clientX / window.innerWidth - 0.5) * 20;
      const y = (event.clientY / window.innerHeight - 0.5) * 20;

      if (bottle) {
        bottle.style.transform =
          `translateY(-10px) rotateY(${x * 0.35}deg) rotateX(${-y * 0.25}deg)`;
      }

      notes.forEach(function (note, index) {
        const speed = (index + 1) * 0.35;
        note.style.transform =
          `translate(${x * speed}px, ${y * speed}px)`;
      });
    });

    wrapper.addEventListener("mouseleave", function () {
      const bottle = wrapper.querySelector(
        ".nlh-bottle, .nlh-placeholder-bottle"
      );
      const notes = wrapper.querySelectorAll(".nlh-note");

      if (bottle) {
        bottle.style.transform = "";
      }

      notes.forEach(function (note) {
        note.style.transform = "";
      });
    });
  }
});


/* =========================
   NISAYI HEADER
========================= */

(function () {
  function initNisayiHeader() {
    const openButtons = document.querySelectorAll(
      "[data-nisayi-menu-open]"
    );
    const closeButtons = document.querySelectorAll(
      "[data-nisayi-menu-close]"
    );
    const drawer = document.querySelector(
      "[data-nisayi-drawer]"
    );

    if (!openButtons.length || !drawer) return;

    function openMenu() {
      document.body.classList.add("nisayi-menu-open");
      drawer.setAttribute("aria-hidden", "false");
    }

    function closeMenu() {
      document.body.classList.remove("nisayi-menu-open");
      drawer.setAttribute("aria-hidden", "true");
    }

    openButtons.forEach(function (button) {
      button.addEventListener("click", openMenu);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener("click", closeMenu);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeMenu();
      }
    });

    drawer.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", closeMenu);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initNisayiHeader
    );
  } else {
    initNisayiHeader();
  }
})();


/* =========================
   NISAYI THE ART OF PRESENCE
========================= */

(function () {
  const sections = document.querySelectorAll(
    "[data-nisayi-presence]"
  );

  if (!sections.length) return;

  sections.forEach(function (section) {
    const tiltArea = section.querySelector(
      "[data-presence-tilt]"
    );
    const bottle = section.querySelector(
      ".nisayi-presence__bottle-wrap"
    );
    const orbs = section.querySelectorAll(
      ".nisayi-presence__orb"
    );

    if (!tiltArea || !bottle) return;

    tiltArea.addEventListener(
      "mousemove",
      function (event) {
        const rect = tiltArea.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        const rotateY =
          (x / rect.width - 0.5) * 8;

        const rotateX =
          (y / rect.height - 0.5) * -8;

        bottle.style.transform =
          `translateY(-10px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;

        orbs.forEach(function (orb, index) {
          const depth = (index + 1) * 4;

          orb.style.transform =
            `translate(${rotateY * depth * 0.15}px, ${rotateX * depth * 0.15}px)`;
        });
      }
    );

    tiltArea.addEventListener(
      "mouseleave",
      function () {
        bottle.style.transform = "";

        orbs.forEach(function (orb) {
          orb.style.transform = "";
        });
      }
    );

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              section.classList.add(
                "nisayi-presence--visible"
              );

              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.25
        }
      );

      observer.observe(section);
    } else {
      section.classList.add(
        "nisayi-presence--visible"
      );
    }
  });
})();




/* =========================
   NISAYI SAFE FAST LOADER
========================= */
/*
(function () {
  let loaderRemoved = false;

  function removeNisayiLoader() {
    if (loaderRemoved) return;

    loaderRemoved = true;

    const loader = document.querySelector(
      "[data-nisayi-site-loader]"
    );

    document.documentElement.classList.remove(
      "nisayi-loading"
    );

    if (document.body) {
      document.body.classList.remove(
        "nisayi-loading"
      );

      document.body.style.overflow = "";
    }

    if (!loader) return;

    loader.classList.add("is-hidden");

    window.setTimeout(function () {
      if (loader.parentNode) {
        loader.parentNode.removeChild(loader);
      }
    }, 300);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      removeNisayiLoader,
      {
        once: true
      }
    );
  } else {
    removeNisayiLoader();
  }

  window.addEventListener(
    "load",
    removeNisayiLoader,
    {
      once: true
    }
  );

  window.setTimeout(
    removeNisayiLoader,
    2000
  );
})();

*/











/* =========================
   NISAYI PRODUCT PAGE
========================= */

(function () {
  function initNisayiProductPage(root) {
    const scope = root || document;

    /* Quantity Plus */
    scope
      .querySelectorAll("[data-nsy-qty-plus]")
      .forEach(function (button) {
        if (
          button.dataset.nsyReady === "true"
        ) {
          return;
        }

        button.dataset.nsyReady = "true";

        button.addEventListener(
          "click",
          function () {
            const qtyBox = button.closest(
              ".nsy-product-qty"
            );

            const input = qtyBox
              ? qtyBox.querySelector(
                  "[data-nsy-qty-input]"
                )
              : null;

            if (!input) return;

            input.value =
              Number(input.value || 1) + 1;

            input.dispatchEvent(
              new Event("change", {
                bubbles: true
              })
            );
          }
        );
      });

    /* Quantity Minus */
    scope
      .querySelectorAll("[data-nsy-qty-minus]")
      .forEach(function (button) {
        if (
          button.dataset.nsyReady === "true"
        ) {
          return;
        }

        button.dataset.nsyReady = "true";

        button.addEventListener(
          "click",
          function () {
            const qtyBox = button.closest(
              ".nsy-product-qty"
            );

            const input = qtyBox
              ? qtyBox.querySelector(
                  "[data-nsy-qty-input]"
                )
              : null;

            if (!input) return;

            input.value = Math.max(
              1,
              Number(input.value || 1) - 1
            );

            input.dispatchEvent(
              new Event("change", {
                bubbles: true
              })
            );
          }
        );
      });

    /* Product Tabs */
    scope
      .querySelectorAll("[data-nsy-tabs]")
      .forEach(function (tabs) {
        if (
          tabs.dataset.nsyReady === "true"
        ) {
          return;
        }

        tabs.dataset.nsyReady = "true";

        const buttons =
          tabs.querySelectorAll(
            "[data-tab-btn]"
          );

        const panels =
          tabs.querySelectorAll(
            "[data-tab-panel]"
          );

        buttons.forEach(function (button) {
          button.addEventListener(
            "click",
            function () {
              buttons.forEach(
                function (item) {
                  item.classList.remove(
                    "active"
                  );
                }
              );

              panels.forEach(
                function (panel) {
                  panel.classList.remove(
                    "active"
                  );
                }
              );

              button.classList.add("active");

              const target =
                tabs.querySelector(
                  '[data-tab-panel="' +
                    button.dataset.tabBtn +
                    '"]'
                );

              if (target) {
                target.classList.add(
                  "active"
                );
              }
            }
          );
        });
      });





    /* =========================================
       NISAYI PRODUCT GALLERY — STABLE VERSION
    ========================================= */

    scope
      .querySelectorAll(".nsy-product-gallery")
      .forEach(function (gallery) {
        /*
          Shopify editor reload aur duplicate JS execution se
          multiple click listeners lagne se rokta hai.
        */
        if (gallery.dataset.nsyGalleryReady === "true") {
          return;
        }

        gallery.dataset.nsyGalleryReady = "true";

        const mainImage = gallery.querySelector(
          "[data-nsy-main-image], .nsy-product-main-img img"
        );

        const mainWrap = gallery.querySelector(
          "[data-nsy-main-wrap], .nsy-product-main-img"
        );

        const thumbnails = Array.from(
          gallery.querySelectorAll("[data-nsy-thumb]")
        );

        if (!mainImage || !thumbnails.length) {
          console.warn(
            "NISAYI Gallery: main image or thumbnails not found."
          );
          return;
        }

        /*
          Har thumbnail se valid full-size image URL collect karo.
        */
        const images = thumbnails
          .map(function (thumbnail) {
            const thumbnailImage =
              thumbnail.querySelector("img");

            const mainUrl =
              thumbnail.dataset.image ||
              thumbnail.dataset.nsyThumb ||
              thumbnail.getAttribute("data-nsy-thumb") ||
              thumbnail.getAttribute("href") ||
              (thumbnailImage
                ? thumbnailImage.currentSrc ||
                  thumbnailImage.src
                : "");

            const popupUrl =
              thumbnail.dataset.popupImage ||
              thumbnail.dataset.zoomImage ||
              mainUrl;

            return {
              main: mainUrl,
              popup: popupUrl
            };
          })
          .filter(function (imageData) {
            return Boolean(imageData.main);
          });

        if (!images.length) {
          console.warn(
            "NISAYI Gallery: no valid image URLs found."
          );
          return;
        }

        let currentIndex = 0;
        let changeTimer = null;
        let imageRequestId = 0;
        let touchStartX = 0;

        function normalizeIndex(index) {
          return (
            (index + images.length) %
            images.length
          );
        }

        function setActiveThumbnail(index) {
          thumbnails.forEach(function (
            thumbnail,
            thumbnailIndex
          ) {
            const isActive =
              thumbnailIndex === index;

            thumbnail.classList.toggle(
              "active",
              isActive
            );

            thumbnail.classList.toggle(
              "is-active",
              isActive
            );

            if (isActive) {
              thumbnail.setAttribute(
                "aria-current",
                "true"
              );
            } else {
              thumbnail.removeAttribute(
                "aria-current"
              );
            }
          });
        }

        function preloadImage(url) {
          return new Promise(function (resolve) {
            const image = new Image();

            image.onload = function () {
              resolve(true);
            };

            image.onerror = function () {
              resolve(false);
            };

            image.src = url;

            /*
              Cached image kabhi onload se pehle complete ho sakti hai.
            */
            if (image.complete) {
              resolve(true);
            }
          });
        }

        async function changeMainImage(index) {
          const newIndex =
            normalizeIndex(index);

          const imageData =
            images[newIndex];

          if (!imageData || !imageData.main) {
            return;
          }

          /*
            Purane pending click/timer ko cancel karo.
          */
          if (changeTimer) {
            window.clearTimeout(changeTimer);
            changeTimer = null;
          }

          /*
            Har image request ka unique ID.
            Purana request latest image ko overwrite nahi karega.
          */
          imageRequestId += 1;

          const requestId =
            imageRequestId;

          currentIndex =
            newIndex;

          /*
            Thumbnail feedback turant dikhega.
          */
          setActiveThumbnail(
            currentIndex
          );

          if (mainWrap) {
            mainWrap.classList.add(
              "is-changing"
            );
          }

          mainImage.style.opacity =
            "0";

          /*
            New image pehle background me load hogi.
          */
          await preloadImage(
            imageData.main
          );

          /*
            User ne is beech doosra thumbnail click kiya ho
            to purani request ignore hogi.
          */
          if (
            requestId !== imageRequestId
          ) {
            return;
          }

          changeTimer =
            window.setTimeout(
              function () {
                /*
                  Bahut important:
                  purana responsive srcset pehle remove karo,
                  uske baad new src assign karo.
                */
                mainImage.removeAttribute(
                  "srcset"
                );

                mainImage.removeAttribute(
                  "sizes"
                );

                mainImage.src =
                  imageData.main;

                mainImage.dataset.nsyZoomImage =
                  imageData.popup ||
                  imageData.main;

                mainImage.style.opacity =
                  "1";

                if (mainWrap) {
                  mainWrap.classList.remove(
                    "is-changing"
                  );
                }

                changeTimer = null;
              },
              100
            );
        }

        /*
          Direct individual listeners ki jagah event delegation.
          Mobile aur desktop dono par zyada reliable.
        */
        gallery.addEventListener(
          "click",
          function (event) {
            const thumbnail =
              event.target.closest(
                "[data-nsy-thumb]"
              );

            if (
              !thumbnail ||
              !gallery.contains(thumbnail)
            ) {
              return;
            }

            event.preventDefault();
            event.stopPropagation();

            const index =
              thumbnails.indexOf(
                thumbnail
              );

            if (index < 0) {
              return;
            }

            changeMainImage(index);
          }
        );
        

        /*
          Touch devices par delayed/suppressed click ke case me
          pointer event backup.
        */
        gallery.addEventListener(
          "pointerup",
          function (event) {
            if (
              event.pointerType !==
              "touch"
            ) {
              return;
            }

            const thumbnail =
              event.target.closest(
                "[data-nsy-thumb]"
              );

            if (
              !thumbnail ||
              !gallery.contains(thumbnail)
            ) {
              return;
            }

            const index =
              thumbnails.indexOf(
                thumbnail
              );

            if (index < 0) {
              return;
            }

            changeMainImage(index);
          },
          {
            passive: true
          }
        );

        setActiveThumbnail(0);

        /* =========================================
           IMAGE POPUP
        ========================================= */

        let modal =
          document.querySelector(
            "[data-nsy-image-modal]"
          );

        if (!modal) {
          modal =
            document.createElement(
              "div"
            );

          modal.className =
            "nsy-image-modal";

          modal.setAttribute(
            "data-nsy-image-modal",
            ""
          );

          modal.setAttribute(
            "aria-hidden",
            "true"
          );

          modal.innerHTML = `
            <button
              type="button"
              class="nsy-image-modal__close"
              data-nsy-modal-close
              aria-label="Close gallery"
            >
              ×
            </button>

            <button
              type="button"
              class="nsy-image-modal__arrow nsy-image-modal__arrow--prev"
              data-nsy-modal-prev
              aria-label="Previous image"
            >
              ←
            </button>

            <div
              class="nsy-image-modal__stage"
              data-nsy-modal-stage
            >
              <img
                src=""
                alt=""
                data-nsy-modal-image
                draggable="false"
              >
            </div>

            <button
              type="button"
              class="nsy-image-modal__arrow nsy-image-modal__arrow--next"
              data-nsy-modal-next
              aria-label="Next image"
            >
              →
            </button>

            <div
              class="nsy-image-modal__counter"
              data-nsy-modal-counter
            ></div>
          `;

          document.body.appendChild(
            modal
          );
        }

        const modalImage =
          modal.querySelector(
            "[data-nsy-modal-image]"
          );

        const modalStage =
          modal.querySelector(
            "[data-nsy-modal-stage]"
          );

        const closeButton =
          modal.querySelector(
            "[data-nsy-modal-close]"
          );

        const previousButton =
          modal.querySelector(
            "[data-nsy-modal-prev]"
          );

        const nextButton =
          modal.querySelector(
            "[data-nsy-modal-next]"
          );

        const counter =
          modal.querySelector(
            "[data-nsy-modal-counter]"
          );

        function updateCounter() {
          if (!counter) {
            return;
          }

          counter.textContent =
            currentIndex +
            1 +
            " / " +
            images.length;
        }

        async function updatePopupImage(
          index
        ) {
          const newIndex =
            normalizeIndex(index);

          const imageData =
            images[newIndex];

          if (
            !modalImage ||
            !imageData
          ) {
            return;
          }

          currentIndex =
            newIndex;

          modal.classList.add(
            "is-changing"
          );

          await preloadImage(
            imageData.popup ||
              imageData.main
          );

          modalImage.src =
            imageData.popup ||
            imageData.main;

          modalImage.alt =
            mainImage.alt ||
            "Product image";

          modal.classList.remove(
            "is-changing"
          );

          setActiveThumbnail(
            currentIndex
          );

          updateCounter();
        }

        function openPopup() {
          if (!modalImage) {
            return;
          }

          const imageData =
            images[currentIndex];

          modalImage.src =
            imageData.popup ||
            imageData.main;

          modalImage.alt =
            mainImage.alt ||
            "Product image";

          updateCounter();

          modal.classList.add(
            "active"
          );

          modal.setAttribute(
            "aria-hidden",
            "false"
          );

          document.body.style.overflow =
            "hidden";
        }

        function closePopup() {
          modal.classList.remove(
            "active"
          );

          modal.classList.remove(
            "is-changing"
          );

          modal.setAttribute(
            "aria-hidden",
            "true"
          );

          document.body.style.overflow =
            "";
        }

        /*
          Main image ko popup opener rakho.
        */
        mainImage.addEventListener(
          "click",
          openPopup
        );

        const openButton =
          gallery.querySelector(
            "[data-nsy-open-gallery]"
          );

        if (openButton) {
          openButton.addEventListener(
            "click",
            function (event) {
              event.preventDefault();
              openPopup();
            }
          );
        }

        if (
          previousButton &&
          previousButton.dataset
            .nsyPopupReady !== "true"
        ) {
          previousButton.dataset.nsyPopupReady =
            "true";

          previousButton.addEventListener(
            "click",
            function (event) {
              event.preventDefault();
              event.stopPropagation();

              updatePopupImage(
                currentIndex - 1
              );
            }
          );
        }

        if (
          nextButton &&
          nextButton.dataset
            .nsyPopupReady !== "true"
        ) {
          nextButton.dataset.nsyPopupReady =
            "true";

          nextButton.addEventListener(
            "click",
            function (event) {
              event.preventDefault();
              event.stopPropagation();

              updatePopupImage(
                currentIndex + 1
              );
            }
          );
        }

        if (
          closeButton &&
          closeButton.dataset
            .nsyPopupReady !== "true"
        ) {
          closeButton.dataset.nsyPopupReady =
            "true";

          closeButton.addEventListener(
            "click",
            function (event) {
              event.preventDefault();
              event.stopPropagation();

              closePopup();
            }
          );
        }

        if (
          modal.dataset
            .nsyBackdropReady !== "true"
        ) {
          modal.dataset.nsyBackdropReady =
            "true";

          modal.addEventListener(
            "click",
            function (event) {
              if (
                event.target === modal
              ) {
                closePopup();
              }
            }
          );
        }

        if (
          modal.dataset
            .nsyKeyboardReady !== "true"
        ) {
          modal.dataset.nsyKeyboardReady =
            "true";

          document.addEventListener(
            "keydown",
            function (event) {
              if (
                !modal.classList.contains(
                  "active"
                )
              ) {
                return;
              }

              if (
                event.key === "Escape"
              ) {
                closePopup();
              }

              if (
                event.key ===
                "ArrowLeft"
              ) {
                updatePopupImage(
                  currentIndex - 1
                );
              }

              if (
                event.key ===
                "ArrowRight"
              ) {
                updatePopupImage(
                  currentIndex + 1
                );
              }
            }
          );
        }

        /* Mobile popup swipe */
        if (
          modalStage &&
          modalStage.dataset
            .nsySwipeReady !== "true"
        ) {
          modalStage.dataset.nsySwipeReady =
            "true";

          modalStage.addEventListener(
            "touchstart",
            function (event) {
              touchStartX =
                event.changedTouches[0]
                  .clientX;
            },
            {
              passive: true
            }
          );

          modalStage.addEventListener(
            "touchend",
            function (event) {
              const touchEndX =
                event.changedTouches[0]
                  .clientX;

              const distance =
                touchEndX -
                touchStartX;

              if (
                Math.abs(distance) <
                45
              ) {
                return;
              }

              if (distance > 0) {
                updatePopupImage(
                  currentIndex - 1
                );
              } else {
                updatePopupImage(
                  currentIndex + 1
                );
              }
            },
            {
              passive: true
            }
          );
        }
      });      





    /* Random Viewer Counter */
    scope
      .querySelectorAll(
        "[data-nsy-viewers]"
      )
      .forEach(function (box) {
        if (
          box.dataset.nsyReady ===
          "true"
        ) {
          return;
        }

        box.dataset.nsyReady =
          "true";

        const number =
          box.querySelector("strong");

        if (!number) return;

        const min = 42;
        const max = 86;

        number.textContent =
          Math.floor(
            Math.random() *
              (max - min + 1)
          ) + min;
      });

   
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        initNisayiProductPage(
          document
        );
      }
    );
  } else {
    initNisayiProductPage(
      document
    );
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initNisayiProductPage(
        event.target
      );
    }
  );
})();
